var mask = "/static/8451851b2306b420.png";

export { mask as default };
//# sourceMappingURL=mask.png.js.map
